export default __webpack_public_path__ + "static/media/marketInquiryIcon.15600beb.svg";